<template>
    <a :href="emailHref">{{ address }}</a>    
</template>
<script>
    export default {
        props: {
            address: {
                type: String,
                required: true,   
            }
        },
        computed: {
            emailHref() {
                return 'mailto:' + this.address
            }
        }
    }
</script>
<style lang="scss">
    
</style>